import * as React from 'react'
import Link from 'next/link';
import UrlTiedNodeInputField from './UrlTiedNodeInputField';
import { useLnRouterUser } from '../../auth/useLnRouterUser';


type Props = {
  searchField: boolean
}


const NodeNavigation: React.FC<Props> = ({ searchField }: Props) => {


  return (
    <div className=" ">
      <div className="mx-auto container items-center">
        <div className=" flex justify-between items-center px-2 md:px-8 pt-2 pb-2">
          <div className="">
          </div>


          <div className="flex items-center  ">


            {searchField &&
              <div className="pl-2 flex-shrink-0">
                <UrlTiedNodeInputField />
              </div>
            }
          </div>

        </div>

      </div>
    </div>
  );
}

export default NodeNavigation;

